// src/shared/xlsx.js — Excel експорт (копие от app.js, Фаза 3).
// XLSX е глобал от public/xlsx.full.min.js. От 29.10.2026 (рецензия, т. 4.1)
// библиотеката (почти 1 MB) се зарежда чак при първия внос/износ, не на
// всяка страница — withXlsx() я дърпа веднъж и после вика сразу.

import { toast } from './toast.js';

let loading = null;
function loadXlsx() {
  if (typeof XLSX !== 'undefined') return Promise.resolve();
  if (!loading) {
    loading = new Promise((resolve, reject) => {
      const s = document.createElement('script');
      s.src = '/xlsx.full.min.js';
      s.onload = () => resolve();
      s.onerror = () => { loading = null; reject(new Error('Excel библиотеката не се зареди — проверете връзката и опитайте пак.')); };
      document.head.appendChild(s);
    });
  }
  return loading;
}

// fn() с налична библиотека. Заредена ли е вече — веднага (синхронно), за
// да не се бавят екраните и тестовете; иначе след зареждането.
export function withXlsx(fn) {
  if (typeof XLSX !== 'undefined') return fn();
  return loadXlsx().then(fn, (e) => { toast(e.message, true); throw e; });
}

export function xlsxDownload(data, sheetName, filename) {
  if (typeof XLSX === 'undefined') { withXlsx(() => xlsxDownload(data, sheetName, filename)).catch(() => {}); return; }
  const ws = XLSX.utils.json_to_sheet(data);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, sheetName || 'Sheet1');
  XLSX.writeFile(wb, filename || 'export.xlsx');
}
